import { gsap, ScrollTrigger, screenSm } from './1.1_animations-defaults.js';
import { smoothScroll } from './1.3_smooth-scroll.js';

const SECTION_ID = 'parrish-co-page-section-c';
const DESKTOP_CLASS = 'desktop';
const HEADING_1_CLASS = 'heading-1';
const HEADING_2_CLASS = 'heading-2';
const HEADING_WRAPPER_CLASS = 'heading-wrapper';
const CONTAINER_WRAPPER_CLASS = 'container-wrapper';
const INNER_CONTAINER_WRAPPER_CLASS = 'inner-container-wrapper';
const HEADING_INNER_WRAPPER_CLASS = 'heading-inner-wrapper';
const TEXT_CLASS = 'text';
const DESKTOP_HEIGHT_FACTOR = 0.4;
const MOBILE_HEIGHT_FACTOR = 1.5;

class AnimationsAboutSectionE {
    constructor() {
        this._section = document.getElementById(SECTION_ID);

        this._section && this._run();
    }
    _run() {
        this._media = gsap.matchMedia();
        this._desktop = this._section.querySelector(`.${DESKTOP_CLASS}`);
        this._containerWrapper = this._desktop.querySelector(`.${CONTAINER_WRAPPER_CLASS}`);
        this._innerContainerWrapper = this._desktop.querySelector(`.${INNER_CONTAINER_WRAPPER_CLASS}`);
        this._heading1 = this._desktop.querySelectorAll(`.${HEADING_1_CLASS}`);
        this._heading2 = this._desktop.querySelectorAll(`.${HEADING_2_CLASS}`);
        this._headingWrapper = this._desktop.querySelector(`.${HEADING_WRAPPER_CLASS}`);
        this._headingInnerWrapper = this._desktop.querySelector(`.${HEADING_INNER_WRAPPER_CLASS}`);
        this._text = this._desktop.querySelectorAll(`.${TEXT_CLASS}`);
        this._count = this._desktop.dataset.count;

        let heightFactor = innerWidth >= screenSm ? DESKTOP_HEIGHT_FACTOR : MOBILE_HEIGHT_FACTOR;
        this._desktop.style.height = `${Math.ceil(this._count * heightFactor)}00vh`;

        this._headingWrapper.style.height = getComputedStyle(this._heading2[0]).height;
        this._heading2.forEach((heading) => {
            heading.classList.remove('absolute');
        });

        this._media.add(
            {
                isDesktop: `(min-width: ${screenSm}px)`,
                isMobile: `(max-width: ${screenSm - 1}px)`,
                reduceMotion: '(prefers-reduced-motion: reduce)',
            },
            this._createAnimationTimeline.bind(this),
        );
    }
    _createAnimationTimeline(context) {
        let { isDesktop, isMobile, reduceMotion } = context.conditions;

        gsap.to(this._innerContainerWrapper, {
            y: 0,
            ease: isDesktop ? 'none' : 'none',
            scrollTrigger: {
                trigger: this._containerWrapper,
                start: 'top 50%',
                end: `bottom bottom`,
                markers: false,
            },
        });

        let prevIndex = 0;
        let currIndex = 0;
        this._animation1 = gsap.timeline({
            scrollTrigger: {
                trigger: this._desktop,
                start: 'top top',
                end: 'bottom bottom',
                markers: false,
                onUpdate: (self) => {
                    let progress = self.progress / (1 / this._count);

                    prevIndex = currIndex;
                    currIndex = Math.ceil(progress);
                    let ease = 'power3.inOut';
                    let duration = 0.9;
                    if (prevIndex !== currIndex && (currIndex - 1 >= 0 || currIndex - 1 <= -100)) {
                        gsap.to(this._headingInnerWrapper, {
                            yPercent: -((100 / this._count) * (currIndex - 1)),
                            duration: duration,
                            ease: ease,
                            onStart: () => {
                                if (isDesktop) {
                                    smoothScroll.lenis.stop();
                                }
                            },
                            onComplete: () => {
                                if (isDesktop) {
                                    smoothScroll.lenis.start();
                                }
                            },
                        });

                        let tl = gsap.timeline({
                            defaults: {
                                duration: duration / 2,
                                ease: ease,
                            },
                        });
                        let tl2 = gsap.timeline({
                            defaults: {
                                duration: duration / 2,
                                ease: ease,
                            },
                        });

                        if (self.direction === 1) {
                            this._text[currIndex - 2] &&
                                tl.to(this._text[currIndex - 2], {
                                    opacity: 0,
                                    // onStart: () => {
                                    //     console.log(currIndex);
                                    //     this._text.forEach((text) => {
                                    //         if (text !== this._text[currIndex - 2]) {
                                    //             gsap.set(text, {
                                    //                 opacity: 0,
                                    //             });
                                    //         }
                                    //     });
                                    // },
                                });
                            this._text[currIndex - 1] &&
                                tl.to(this._text[currIndex - 1], {
                                    opacity: 1,
                                    onUpdate: () => {
                                        this._text.forEach((text) => {
                                            if (text !== this._text[currIndex - 1]) {
                                                gsap.set(text, {
                                                    opacity: 0,
                                                });
                                            }
                                        });
                                    },
                                });
                        } else {
                            this._text[currIndex] &&
                                tl.to(this._text[currIndex], {
                                    opacity: 0,
                                    // onStart: () => {
                                    //     console.log(currIndex);
                                    //     this._text.forEach((text) => {
                                    //         if (text !== this._text[currIndex]) {
                                    //             gsap.set(text, {
                                    //                 opacity: 0,
                                    //             });
                                    //         }
                                    //     });
                                    // },
                                });
                            this._text[currIndex - 1] &&
                                tl.to(this._text[currIndex - 1], {
                                    opacity: 1,
                                    onUpdate: () => {
                                        this._text.forEach((text) => {
                                            if (text !== this._text[currIndex - 1]) {
                                                gsap.set(text, {
                                                    opacity: 0,
                                                });
                                            }
                                        });
                                    },
                                });
                        }

                        if (self.direction === 1) {
                            this._heading1[currIndex - 2] &&
                                tl2.to(this._heading1[currIndex - 2], {
                                    opacity: 0,
                                    // onStart: () => {
                                    //     console.log(currIndex);
                                    //     this._heading1.forEach((text) => {
                                    //         if (text !== this._heading1[currIndex - 2]) {
                                    //             gsap.set(text, {
                                    //                 opacity: 0,
                                    //             });
                                    //         }
                                    //     });
                                    // },
                                });
                            this._heading1[currIndex - 1] &&
                                tl2.to(this._heading1[currIndex - 1], {
                                    opacity: 1,
                                    onUpdate: () => {
                                        this._heading1.forEach((text) => {
                                            if (text !== this._heading1[currIndex - 1]) {
                                                gsap.set(text, {
                                                    opacity: 0,
                                                });
                                            }
                                        });
                                    },
                                });
                        } else {
                            this._heading1[currIndex] &&
                                tl2.to(this._heading1[currIndex], {
                                    opacity: 0,
                                    // onStart: () => {
                                    //     console.log(currIndex);
                                    //     this._heading1.forEach((text) => {
                                    //         if (text !== this._heading1[currIndex]) {
                                    //             gsap.set(text, {
                                    //                 opacity: 0,
                                    //             });
                                    //         }
                                    //     });
                                    // },
                                });
                            this._heading1[currIndex - 1] &&
                                tl2.to(this._heading1[currIndex - 1], {
                                    opacity: 1,
                                    onUpdate: () => {
                                        this._heading1.forEach((text) => {
                                            if (text !== this._heading1[currIndex - 1]) {
                                                gsap.set(text, {
                                                    opacity: 0,
                                                });
                                            }
                                        });
                                    },
                                });
                        }
                    }
                },
            },
        });
    }
}
const animationsAboutSectionE = new AnimationsAboutSectionE();
